
(function () {
  var duration = 350;

  function getProductAccordions() {
    return document.querySelectorAll('.product__accordion.accordion details');
  }

  function setupAccordion(details) {
    if (details.dataset.smoothAccordionReady === 'true') return;

    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');

    if (!summary || !content) return;

    details.dataset.smoothAccordionReady = 'true';

    content.style.overflow = 'hidden';
    content.style.transition = 'height ' + duration + 'ms ease, opacity ' + duration + 'ms ease';

    if (details.open) {
      content.style.height = 'auto';
      content.style.opacity = '1';
      summary.setAttribute('aria-expanded', 'true');
    } else {
      content.style.height = '0px';
      content.style.opacity = '0';
      summary.setAttribute('aria-expanded', 'false');
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.dataset.animating === 'true') return;

      if (details.open) {
        closeAccordion(details, summary, content);
      } else {
        openAccordion(details, summary, content);
      }
    });
  }

  function openAccordion(details, summary, content) {
    details.dataset.animating = 'true';
    details.open = true;
    summary.setAttribute('aria-expanded', 'true');

    content.style.height = '0px';
    content.style.opacity = '0';

    requestAnimationFrame(function () {
      content.style.height = content.scrollHeight + 'px';
      content.style.opacity = '1';
    });

    setTimeout(function () {
      content.style.height = 'auto';
      details.dataset.animating = 'false';
    }, duration);
  }

  function closeAccordion(details, summary, content) {
    details.dataset.animating = 'true';

    content.style.height = content.scrollHeight + 'px';
    content.style.opacity = '1';

    requestAnimationFrame(function () {
      content.style.height = '0px';
      content.style.opacity = '0';
    });

    setTimeout(function () {
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
      details.dataset.animating = 'false';
    }, duration);
  }

  function initSmoothAccordions() {
    getProductAccordions().forEach(setupAccordion);
  }

  document.addEventListener('DOMContentLoaded', initSmoothAccordions);
  document.addEventListener('shopify:section:load', initSmoothAccordions);

  initSmoothAccordions();
})(); 